import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./AllNewPackages.css";
import OurNewPackages from "./OurNewPackages";
import {
  getAllPackageList,
  getPackageCategory,
  getPackageFilter,
  getPackageList,
  setCity,
} from "../../Redux/Actions";
import { useState } from "react";
import { Scroll } from "../../components/Scroll function/scroll";
import PackageName from "./PackageName";
import { useHistory, useParams } from "react-router-dom";
import Pagination from "../../components/Pagination/Pagination";
import "../../components/Pagination/Pagination.css";
import { AiFillRightCircle } from "react-icons/ai";
import { AiFillLeftCircle } from "react-icons/ai";
import { loader } from "mini-css-extract-plugin";
import Loader from "../../components/Loader/Loader";
import Meta from "../../components/Meta";
import Loadable from "react-loadable";
import { WindowTwoTone } from "@mui/icons-material";

/* Lazy load components starts */
const TopNav = Loadable({
  loader: () => import("../../components/TopNav/TopNav"),
  loading: Loader,
});

const Header = Loadable({
  loader: () => import("../../components/Header/Header"),
  loading: Loader,
});

const ScrolltoTop = Loadable({
  loader: () => import("../../components/Scrolltotop/ScrolltoTop"),
  loading: Loader,
});

const Footer = Loadable({
  loader: () => import("../../components/Footer/Footer"),
  loading: Loader,
});

const SubFooter = Loadable({
  loader: () => import("../../components/SubFooter/SubFooter"),
  loading: Loader,
});

const SimpleForm = Loadable({
  loader: () => import("../../components/chatbot/SimpleForm"),
  loading: Loader,
});

const NewHeader = Loadable({
  loader: () => import("../../components/NewHeader/NewHeader"),
  loading: Loader,
});

function AllNewPackages({ location }) {
  const packagelist1 = useSelector((state) => state.packageList);

  const Package_Categories = useSelector((state) => state.packageCategory);
  const Package_Filtered = useSelector((state) => state.packageFilter);

  const navCity = useSelector((state) => state.navCityList);
  const { navCities, loading: loadingNavCities } = navCity;

  //  console.log(packagelist1?.packages,"tyuti");
  const { loading, packages } = packagelist1;

  const [page, setPage] = useState(1);

  const [Package_Category, setPackage_Category] = useState("");

  // const [AllPackages_active, setAllPackages_active] = useState(false);

  const dispatch = useDispatch();
  const { state } = location;
  const [activePackage, setactivePackage] = useState("");
  const [searchFromButton, setsearchFromButton] = useState(state);
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const [pagination, setpagination] = useState(true);
  const AllpackageListing = useSelector((state) => state.allpackage);
  const { AllpackDetail, loading: clickLoader } = AllpackageListing;
  const filPack = AllpackageListing?.AllpackDetail?.results;
  // console.log("filter pacakges ",filPack.length)
  const [allPack, setallPack] = useState(true);
  const [metaTitle, setMetaTitle] = useState("");

  useEffect(() => {
    setsearchFromButton(state);
    if (state?.length > 0) {
      // setAllPackages_active(true)
      setpagination(false);
      setactivePackage("");
    } else if (state?.length === 0) {
      console.log("search becomes zero length");
    }
  }, [state]);

  const FilterOnclick = (packageName) => {
    dispatch(getAllPackageList(packageName, citySelect));
    setallPack(false);
    setpagination(false);
  };
  const handleActivePage = () => {
    //setFiltered(packages?.results);
    setsearchFromButton("");
    setactivePackage("");
    setpagination(true);
    setallPack(true);
  };

  const { loading: loadingCity, citySelect } = citySelected;

  const currentCity = useRef();

  const { citySlug } = useParams();
  const history = useHistory();

  useEffect(() => {
    dispatch(getPackageList(page, "", citySelect));
  }, [page]);

  useEffect(() => {
    currentCity.current = citySelect;
    try {
      let NewArray = citySlug.replace(" ", "_").split("_");
      let firstName =
        NewArray[0].substring(0, 1).toUpperCase() + NewArray[0].substring(1);
      var JoinedCityName = firstName;
      if (NewArray.length > 1) {
        let secondName =
          NewArray[1].substring(0, 1).toUpperCase() + NewArray[1].substring(1);
        JoinedCityName = firstName + "_" + secondName;
      }
    } catch (error) {
      console.log(error);
    }
    Scroll();
    dispatch(setCity(JoinedCityName));
  }, []);

  useEffect(() => {
    setMetaTitle("Health Checkup Package -" + citySelect);
  }, [citySelect]);

  // useEffect(() => {
  //   if(!packages?.results)
  //   dispatch(getPackageList(counter));
  // }, []);

  // const filterFunc = (id) => {
  //   const Filter_Packages = packages?.results.filter((value) => {
  //     return value.id == id;
  //   });
  //    setFiltered(Filter_Packages);
  // };

  // useEffect(() => {
  //   if(packages?.results && Filtered ){
  //     setFiltered([...Filtered,...packages.results])
  //   }
  // }, [counter])

  useEffect(() => {
    if (currentCity.current !== citySelect) {
      dispatch(getPackageList(1, "", citySelect));
      window.location.href= (process.env.RAZZLE_APP_BASE_URL +
        `/health-checkup-packages${citySelected.citySelect != ""
          ? `/${citySelected.citySelect.toLowerCase().replace(" ", "-")}`
          : ""
        }`
      );
    }
  }, [citySelected.citySelect]);

  const onPageChanged = (data) => {
    const { currentPage } = data;
    dispatch(getPackageList(currentPage, "", citySelect));
  };
  function scrollWin() {
    var div = document.getElementById("allPackage");
    div.scrollBy(100, 0);
  }
  function scrollLeftWin() {
    var div = document.getElementById("allPackage");
    div.scrollBy(-100, 0);
  }

  const getAllPackage = (e) => {
    e.preventDefault();
    if (currentCity.current !== citySelect) {
      window.location.href= ({
        pathname: process.env.RAZZLE_APP_BASE_URL + `/health-checkup-packages/${citySelected.citySelect
          .toLowerCase()
          .replace(" ", "_")}`,

        state: [AllpackDetail.results],
      });
    }
  };
  const packageCategories = [
    {
      id: 1,
      name: "Full body",
    },
    {
      id: 2,
      name: "Fever ",
    },
    {
      id: 3,
      name: "Covid ",
    },
    {
      id: 4,
      name: "Dengue ",
    },
    {
      id: 5,
      name: "Heart ",
    },
    {
      id: 6,
      name: "HIV",
    },
    {
      id: 7,
      name: "Women ",
    },
    {
      id: 8,
      name: "Liver ",
    },
    {
      id: 9,
      name: "Hair ",
    },
  ];
  return (
    <>
      <Meta
        title={metaTitle}
        description="Redcliffe Life Diagnostics is top among the reliable diagnostic centres and certified pathology labs in India. You can get the accurate reports for all the medical tests."
        keywords="health Packages"
      ></Meta>
      <NewHeader />
      <div className="backgroundColor">
        <div className="AllNewPackages AllNewPackages2">
          <div className="allpackagesheading">
            <h1>Our Top Packages</h1>
          </div>
          <div className="scrollBtn">
            <div className="scrollLeftDiv" onClick={scrollLeftWin}>
              <AiFillLeftCircle className="rightIcon" />
            </div>
            <div className="scrollRightDiv" onClick={scrollWin}>
              <AiFillRightCircle className="rightIcon" />
            </div>
          </div>
          <div className="AllpackagesDiv" id="allPackage">
            <div className="AllpackagesName">
              <div
                className={
                  activePackage == ""
                    ? "AllpackagesBlock fontColoR"
                    : "AllpackagesBlock"
                }
                onClick={handleActivePage}
              >
                All Packages
              </div>

              {loading
                ? "loading"
                : packageCategories?.map((value, index) => (
                  <div
                    className="packagesName"
                    onClick={() => {
                      setPackage_Category(value.name);
                      setsearchFromButton("");
                      setactivePackage(value.name);
                      FilterOnclick(value.name);
                    }}
                    key={value.id}
                  >
                    <PackageName
                      value={value.name}
                      activePackage={activePackage}
                      state={state}
                    />
                  </div>
                ))}
            </div>
          </div>
          <div className="PackageList">
            {/* {console.log(Filtered)} */}
            {/* {Filtered && Filtered !==""  ? ( <OurNewPackages values={Filtered} />) : ( <OurNewPackages values={packages} />) } */}

            {searchFromButton?.length > 0 ? (
              <OurNewPackages values={searchFromButton[0]} />
            ) : allPack ? (
              <OurNewPackages values={packages?.results} />
            ) : clickLoader ? (
              <Loader />
            ) : (
              <OurNewPackages values={filPack} />
            )}
          </div>
          <div className="See_more_Div">
            {pagination ? (
              <Pagination
                onPageChanged={onPageChanged}
                pageNeighbours={1}
                pageLimit={Number(packages.page_size)}
                totalRecords={packages.count}
                currentPage={page}
                setCurrentPage={setPage}
              />
            ) : null}

            {/* <button onClick={SeeMoreButn}>See more</button> */}
          </div>
        </div>
      </div>
      <Footer />
      <div className="chatbot">
        <SimpleForm />
      </div>
      {/* <SubFooter /> */}
      <ScrolltoTop />
    </>
  );
}
export default {
  component: AllNewPackages,
};
